import { sanitizeString } from './sanitizeString';
export const sanitizeFileName = (fileName) => {
    return sanitizeString({
        string: fileName,
        trim: true,
        removeDuplicateSpaces: true,
        toLowerCase: true,
        onlyHyphenMinus: true,
        replaceSpacesWith: '_',
        alphaNumericOnly: {
            charactersToKeep: ['-', '_', '(', ')', '.'],
            keepSpacesBetweenWords: true,
        },
    });
};
//# sourceMappingURL=sanitizeFileName.js.map